module.exports = __webpack_public_path__ + "static/media/foto.5a0c77fc.png";